export const isNameValid = (name: string) => name.length > 50

export const isEmpty = (str: string) => str.length === 0
